import { render, staticRenderFns } from "./baijinReport.vue?vue&type=template&id=2ee4c630&scoped=true"
import script from "./baijinReport.vue?vue&type=script&lang=js"
export * from "./baijinReport.vue?vue&type=script&lang=js"
import style0 from "./baijinReport.vue?vue&type=style&index=0&id=2ee4c630&prod&scoped=true&lang=css"
import style1 from "./baijinReport.vue?vue&type=style&index=1&id=2ee4c630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee4c630",
  null
  
)

export default component.exports